import React, { PureComponent } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import {
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';

import {
  I18n,
  Menu,
} from 'components';

import Notifications from './containers/Notifications';
import PasswordAndAccess from './containers/PasswordAndAccess';
import NumberManagement from './containers/NumberManagement';
import ServiceContract from './containers/ServiceContract';
import PassportUpload from './containers/PassportUpload';
import { withViewAnalytics } from '../../utils/hocs/withViewAnalytics';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

class Settings extends PureComponent {
  render() {
    const {
      isRestrictedAccess,
      match,
      history,
      location,
      contract,
      needRefreshPersonalData,
      isPorted,
      personalData,
    } = this.props;

    if (isRestrictedAccess) {
      return <Redirect to="/" />;
    }

    const numberManagementUrl = `${match.path}/number-management`;
    const notificationsUrl = `${match.path}/notifications`;
    const passwordAndAccessUrl = `${match.path}/password-and-access`;
    const userFormUrl = `${match.path}/user-form`;
    const passportUploadUrl = `${match.path}/passport-upload`;
    const serviceContractUrl = `${match.path}/service-contract`;
    const redirectUrl = isPorted ? passwordAndAccessUrl : numberManagementUrl;

    const portedSettings = [{
      id: 0,
      url: passwordAndAccessUrl,
      label: <I18n path="settings.passwordAndAccess.name" />,
    }];

    const entries = [{
      id: 0,
      url: numberManagementUrl,
      label: <I18n path="settings.numberManagement.name" />,
    },
    {
      id: 1,
      url: notificationsUrl,
      label: <I18n path="settings.notifications.name" />,
    },
    {
      id: 2,
      url: passwordAndAccessUrl,
      label: <I18n path="settings.passwordAndAccess.name" />,
    }];

    if (contract) {
      entries.push({
        id: 4,
        url: serviceContractUrl,
        label: <I18n path="settings.serviceContract.name" />,
      });
    }

    if (needRefreshPersonalData) {
      entries.push({
        id: 5,
        url: passportUploadUrl,
        label: <I18n path="settings.passportUpload.name" />,
      });
    }

    const currentMenuEntries = isPorted ? portedSettings : entries;
    const activeEntry = currentMenuEntries.findIndex(({ url }) => {
      const path = location.pathname.replace(/\/$/, '');
      return path === url;
    });

    return (
      <div className={cx('page')}>
        <Menu
          className={cx('navigation')}
          entries={currentMenuEntries}
          activeEntry={activeEntry}
          onEntryClick={({ url }) => history.push(url)}
        />
        <Switch>
          <Route
            component={NumberManagement}
            path={numberManagementUrl}
            exact
          />
          <Route
            component={Notifications}
            path={notificationsUrl}
            exact
          />
          <Route
            component={PasswordAndAccess}
            path={passwordAndAccessUrl}
            exact
          />
          {needRefreshPersonalData && (
            <Route
              component={() => <PassportUpload data={personalData} />}
              path={passportUploadUrl}
              exact
            />
          )}
          {contract && (
            <Route
              component={() => <ServiceContract data={contract} />}
              path={serviceContractUrl}
              exact
            />
          )}
          <Redirect to={redirectUrl} />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  contract: state.application.settings.contract,
  needRefreshPersonalData: state.application.settings.needRefreshPersonalData,
  isPorted: state.application.isPorted,
  personalData: state.application.settings.personalData,
});

Settings.propTypes = {
  isRestrictedAccess: PropTypes.bool,
  match: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
  contract: PropTypes.object,
  needRefreshPersonalData: PropTypes.any,
  isPorted: PropTypes.bool,
};

export default compose(
  connect(mapStateToProps),
  withViewAnalytics,
)(Settings);
